import { Link } from "react-router-dom";

interface TitleBarProps{
    title:string;
    subTitle?:string;
}
const TitleBar : React.FC<TitleBarProps> = ({title,subTitle}) => {
    return (
        <>
            <div className="pt-10 pb-0 group font-bold px-4 sm:px-10">
                <p className="text-custom-secolor main-heading text-opacity-80 animate-pulse ">{title}</p>
                <p className="text-md pt-2 text-custom-secolor">{subTitle}</p> 
                    <div className="title-divider mb-10"> 
                    </div>
            </div>
        </>
    )
}
export default TitleBar